import { render, staticRenderFns } from "./courseCreate.vue?vue&type=template&id=113a0d0a&scoped=true&"
import script from "./courseCreate.vue?vue&type=script&lang=js&"
export * from "./courseCreate.vue?vue&type=script&lang=js&"
import style0 from "./courseCreate.vue?vue&type=style&index=0&id=113a0d0a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "113a0d0a",
  null
  
)

export default component.exports